import {useQuery, gql} from '@apollo/client'

const groupPermissionDetails = gql`
  query groupPermissionDetails($groupId: Numeric, $clientId: Numeric) {
    groupPermissionList(groupId: $groupId, clientId: $clientId) {
      CLIENT_ID
      GROUP_ID
      GROUP_NAME
      CLIENT_ID
      DESCRIPTION
      JURISDICTION
      FILTERS
      DATA_AGGREGATION
      TREND_ANALYSIS_FLAG
      CHATBOT_FLAG
      CHATBOT_EXPORT_FLAG
      CHATBOT_COPY_FLAG
      EXPORT_FLAG
      BENEFITS
      WORKFORCES
      USECASE
      POINT_OF_INTEREST
      PERSONA_FLAG
    }
  }
`

export function useGetGroupPermissionDetails(groupId, clientId) {
  const {
    data: groupPermissionListDetails,
    loading: loadingGroupPermission,
    refetch: refetchGroupPermission,
    error: errorGroupPermissions
  } = useQuery(groupPermissionDetails, {
    context: {clientName: 'adminPanel'},
    variables: {groupId, clientId},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip: !groupId || !clientId
  })
  return {groupPermissionListDetails, loadingGroupPermission, errorGroupPermissions, refetchGroupPermission}
}
